(() => {
  const bootstrap = document.getElementById('amana-tolstoy-loader');
  if (!bootstrap || window.amanaTolstoyLoaderStarted) return;
  window.amanaTolstoyLoaderStarted = true;

  const selector = '[data-publish-id], [data-tolstoy-publish-id]';
  const isVideoBlock = (element) => {
    const publishId = element.getAttribute('data-publish-id') || element.getAttribute('data-tolstoy-publish-id');
    return Boolean(publishId?.trim()) && (
      element.tagName.toLowerCase().startsWith('tolstoy-') ||
      element.hasAttribute('data-tolstoy-publish-id') ||
      [...element.classList].some((name) => name.startsWith('tolstoy-'))
    );
  };
  const containsVideo = (root) => (
    (root.nodeType === 1 && root.matches(selector) && isVideoBlock(root)) ||
    [...root.querySelectorAll(selector)].some(isVideoBlock)
  );
  let loaded = false;
  let observer;

  const load = () => {
    if (loaded || !containsVideo(document)) return;
    loaded = true;
    observer?.disconnect();
    window.tolstoyCurrencySymbol = bootstrap.dataset.currencySymbol;
    window.tolstoyMoneyFormat = bootstrap.dataset.moneyFormat;

    const attributes = {
      'data-shop': bootstrap.dataset.shop,
      'data-app-key': bootstrap.dataset.appKey,
      'data-should-use-cache': 'true',
      'data-product-gallery-projects': '[]',
      'data-collection-gallery-projects': '[]',
      'data-product-id': bootstrap.dataset.productId,
      'data-collection-id': bootstrap.dataset.collectionId,
      'data-template-name': bootstrap.dataset.templateName,
      'data-customer-id': bootstrap.dataset.customerId,
      'data-shop-assistant-enabled': 'false',
      'data-search-bar-widget-enabled': 'false',
      'data-ot-ignore': '',
      'data-cookieconsent': 'ignore',
    };
    const engines = [
      ['https://widget.gotolstoy.com/we/widget.js', ''],
      ['https://play.gotolstoy.com/widget-v2/widget.js', 'tolstoy-widget-script'],
      ['https://play.gotolstoy.com/widget-v2/widget.brand-mcp.js', ''],
    ];

    for (const [src, id] of engines) {
      if ([...document.scripts].some((script) => script.src === src)) continue;
      const script = document.createElement('script');
      script.type = 'module';
      script.async = true;
      script.src = src;
      if (id) script.id = id;
      for (const [name, value] of Object.entries(attributes)) {
        script.setAttribute(name, value || '');
      }
      document.head.appendChild(script);
    }
  };

  const start = () => {
    load();
    if (loaded || !document.body) return;
    observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => [...mutation.addedNodes].some((node) => (
        node.nodeType === 1 && containsVideo(node)
      )))) load();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  document.addEventListener('shopify:section:load', load);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
